import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Dropdown } from 'semantic-ui-react'
import i18n from '~/components/i18n'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { SwissQuery } from '~/QueryHooks/SwissQuery'

const getDefaultTableColumnHeaders = () => [
  {
    name: i18n.t('Tour data id'),
    key: 'uniqueId',
    sorted: 'desc'
  },
  {
    name: i18n.t('Date'),
    key: 'date',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
    sorted: 'desc'
  },
  {
    name: i18n.t('Date start'),
    key: 'timeFrom'
  },
  {
    name: i18n.t('Date end'),
    key: 'timeTo'
  },
  {
    name: i18n.t('Amount accepted (in l)'),
    key: 'amount',
    type: 'no-unit-number',
    decimalScale: 0,
    sorted: 'desc'
  },
  {
    name: i18n.t('avg. Temp. (°C)'),
    key: 'avgTemp',
    type: 'no-unit-number',
    decimalScale: 1,
    sorted: 'desc'
  },
  {
    name: i18n.t('Sample bottle'),
    key: 'sampleBottleNumber'
  },
  {
    name: i18n.t('Sample Compartment Temp (°C)'),
    key: 'sampleAvgTemp',
    type: 'no-unit-number',
    decimalScale: 1,
    sorted: 'desc'
  }
]

const MilkDeliveries: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0,
    month: ''
  })

  const [tableColumnHeaders, setTableColumnHeaders] = useState(getDefaultTableColumnHeaders())

  const {
    data: milkDeliveries,
    isLoading: isLoadingMilkDel,
    isFetching: isFetchingMilkDel,
    refetch: fetchMilkDel
  } = SwissQuery.getSwissMilkDeliveries(id, {
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  const {
    data: milkDelData,
    isLoading: isLoadingMilkDelData,
    refetch: fetchMilkDelData
  } = SwissQuery.getSwissMilkDeliveriesData(id)

  useEffect(() => {
    fetchMilkDel()
    fetchMilkDelData()
    setTableColumnHeaders(getDefaultTableColumnHeaders())
  }, [t])

  useEffect(() => {
    fetchMilkDel()
  }, [dataFiltered])

  useEffect(() => {
    if (milkDelData && !dataFiltered.month) {
      setDataFiltered({
        ...dataFiltered,
        month: milkDelData?.months[0]?.key
      })
    }
  }, [milkDelData])

  function renderMonthFilter() {
    return <>
      <Dropdown
        selectOnBlur={false}
        placeholder={t('Select date')}
        selection
        options={milkDelData?.months?.map(month => ({ text: month.label, value: month.key })) || []}
        value={dataFiltered.month}
        onChange={(_, { value }) => {
          setDataFiltered({
            ...dataFiltered,
            month: value as string
          })
        }}
      />
    </>
  }

  function renderTable() {
    return <TableComponent
      isFetchingData={isFetchingMilkDel}
      animated
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      rows={rows}
      total={filtered}
    />
  }

  const { filtered, rows } = milkDeliveries ? milkDeliveries : { filtered: 0, rows: [] };

  return <Layout
    title={''}
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    filters={renderMonthFilter()}
    useSpinner
    isBusy={isLoadingMilkDel || isLoadingMilkDelData}
  >
    {renderTable()}
  </Layout>
}
export default MilkDeliveries